import { createSlice } from "@reduxjs/toolkit"

import { SHOPIFY_MOVE_SLICE_NAME } from "./shopifyMove.constants"
import { moveShopifyStore } from "./shopifyMove.thunks"

const initialState = {
  // `shopify_move` from GET /auth/shopify_auth/ — its presence is what tells the
  // OAuth return page to offer the move instead of following `url`.
  offer: null,
  // `url` from the same response — where the OAuth page would have sent the user
  // had the store not been movable; the fallback for leaving the page on Cancel.
  returnUrl: null,
  fetching: false,
  // 200 body of POST /user/shopify/move/ — feeds the success toast.
  moveResult: null,
  errors: null
}

const slice = createSlice({
  name: SHOPIFY_MOVE_SLICE_NAME,
  initialState,
  reducers: {
    setShopifyMoveOffer: (state, { payload }) => {
      state.offer = payload?.offer
      state.returnUrl = payload?.returnUrl
      state.moveResult = null
      state.errors = null
    },
    resetShopifyMove: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(moveShopifyStore.pending, (state) => {
        state.fetching = true
        state.errors = null
      })
      .addCase(moveShopifyStore.fulfilled, (state, { payload }) => {
        state.fetching = false
        state.moveResult = payload
        state.offer = null
      })
      .addCase(moveShopifyStore.rejected, (state, { payload }) => {
        state.fetching = false
        state.errors = payload
      })
  }
})

export const { setShopifyMoveOffer, resetShopifyMove } = slice.actions

export const selectShopifyMoveOffer = (state) => state[SHOPIFY_MOVE_SLICE_NAME]?.offer
export const selectShopifyMoveReturnUrl = (state) => state[SHOPIFY_MOVE_SLICE_NAME]?.returnUrl
export const selectShopifyMoveFetching = (state) => state[SHOPIFY_MOVE_SLICE_NAME]?.fetching

// Deliberately not persisted: the offer only makes sense inside a single OAuth
// return, and a rehydrated one would re-open the popups on an unrelated page.
// The slice key is in the top-level `blacklist` in src/store.js for the same reason.
export const reducer = slice.reducer
